import { Outlet, useLocation } from "react-router-dom";
import { Avatar, Button, Col, Layout, Menu, Popover, Row, Tooltip } from "antd";
import React, { useEffect, useState } from 'react';
import { useApp } from "@essenza/react";

import { UserOutlined } from '@ant-design/icons';
import { ReactComponent as Logo } from '../assets/svg/logo-ssati-network.svg';
import { ReactComponent as JobIcon } from "../assets/svg/job-icon.svg";
import { ReactComponent as CompanyIcon } from '../assets/svg/company-icon.svg';
import { ReactComponent as StudentIcon } from '../assets/svg/student-icon.svg';
import { ReactComponent as NewIcon } from '../assets/svg/new-application-icon.svg';
import { ReactComponent as Search } from '../assets/svg/ricerca.svg';
import { ReactComponent as Closed } from '../assets/svg/Chiuse.svg';

// import { ReactComponent as CompaniesIcon } from '../assets/svg/companies-icon.svg';
import { ReactComponent as NotificationIcon } from '../assets/svg/notification-icon.svg';

const { Header, Content } = Layout;

export function MainLayout({ token }) {
  const app = useApp();
  const [open, setOpen] = useState(false);
  const control = token.current?.control; //{navigate: ()=>null}; //
  console.log("TEST EFFECT LAYOUT", app, token);
  const location = useLocation();
  useEffect(()=>{
    console.log("TEST EFFECT LAYOUT 2", token);
  },[token])
  const ioption = <div >
    <Button onClick={() => { setOpen(false); control.navigate("/iaziendains"); }} className="insert-button spacing-b10" style={{ display: "flex", alignItems: "center" }} icon={<CompanyIcon />}>
      Azienda
    </Button>
    <Button onClick={() => { setOpen(false); control.navigate("/istudenteins"); }} className="insert-button" style={{ display: "flex", alignItems: "center" }} icon={<StudentIcon />}>
      Studente
    </Button>
  </div>
  return (
    <Layout className="layout">
      {/* <AppSider model={App.model}></AppSider> */}
      <Layout className="layout">
        <Header className="layout-header">
          {/* {app.logged &&  */}
          <Row>
            <Col flex="none">
              <Logo style={{ verticalAlign: "top" }} alt="Logo" />
            </Col>
            <Col flex="auto">

            </Col>
            {/*  <Col flex="400px">
              <Menu mode="horizontal">
                <Menu.Item icon={<JobIcon />}>
                  Job
                </Menu.Item>
                <Menu.Item icon={<NewIcon />}>
                  Inserisci
                </Menu.Item>
              </Menu>
            </Col> */}
            <Col flex="40px" className="avatar-column">
              <span className="pointer" onClick={() => control.navigate("/offerte")}>
                <div>
                  <JobIcon className={(location?.pathname === '/offerte' ? 'iselected' : '')}  />
                </div>
                <h6 className={"text-center " + (location?.pathname !== '/offerte' ? 'uselected' : '')}>
                  Offerte
                </h6>
              </span>
            </Col>
            <Col flex="60px" className="avatar-column" >
                <span className="pointer" onClick={() => control.navigate("/offerta")}>
                  <div>
                    <NewIcon className={'pointer ' + (location?.pathname === '/offerta'? 'iselected' : '')} />
                  </div>
                  <h6 className={"text-center " + (location?.pathname !== '/offerta' ? 'uselected' : '')}>
                    Crea offerta
                  </h6>
                </span>
            </Col>
            <Col flex="60px" className="avatar-column" >
                <span className="pointer" onClick={() => control.navigate("/chiuse")}>
                  <div>
                    <Closed className={'pointer ' + (location?.pathname === '/chiuse'? 'iselected' : '')} />
                  </div>
                  <h6 className={"text-center " + (location?.pathname !== '/chiuse' ? 'uselected' : '')}>
                    Chiuse
                  </h6>
                </span>
            </Col>
            <Col flex="40px" className="avatar-column">
              <span className="pointer" onClick={() => control.navigate("/allcandidati")}>
                <div>
                  <Search className={(location?.pathname === '/allcandidati' ? 'iselected' : '')}  />
                </div>
                <h6 className={"text-center " + (location?.pathname !== '/allcandidati' ? 'uselected' : '')}>
                  Ricerca
                </h6>
              </span>
            </Col>
            <Col flex="auto">

            </Col>
            {/* <Col flex="60px" className="avatar-column">
              <Tooltip placement="bottom" title="Notifiche" color="#264395">
                <NotificationIcon className={'pointer ' + (location?.pathname === '/corsi' ? 'iselected' : '')} onClick={() => control.navigate("/notifications")} />
              </Tooltip>
            </Col> */}
            <Col flex="none" className="avatar-column">
              <Tooltip placement="bottom" title="Profilo" color="#264395">
                <Avatar className="pointer" onClick={() => control.navigate("/profile")} size={36} icon={<UserOutlined />} />
              </Tooltip>
            </Col>
          </Row>
          {/* } */}
        </Header>
        <Content
          className="layout-bg layout-content"
          style={{
            padding: 0,
            minHeight: 280,
          }}
        >
          <Outlet></Outlet>
        </Content>
      </Layout>
    </Layout>
  );
}